import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/caikuma_invitation_campaign.svg?webp'


const _withScopeId = n => (_pushScopeId("data-v-0af4488f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "banner-background p-3" }
const _hoisted_3 = { class: "banner-section-background" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-flex flex-column align-items-center pt-3 pb-2 pl-3 banner-main-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bolder text-nowrap d-flex justify-content-between w-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold highlight mr-1" }, "\\"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "招待してくれたあなたに"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold highlight ml-1" }, "/")
], -1))
const _hoisted_7 = { class: "text-size-48 font-weight-bolder highlight" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-size-20 font-weight-bolder highlight" }, "pt", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-size-10" }, "※", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bolder text-nowrap d-flex justify-content-between w-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold highlight mr-1" }, "/"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "プレゼント"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold highlight ml-1" }, "\\")
], -1))
const _hoisted_11 = { class: "d-flex justify-content-start align-items-baseline w-100 mt-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-size-10" }, "※", -1))
const _hoisted_13 = { class: "text-size-12 text-bolder" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-size-10" }, "相当", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ml-auto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "banner-img pr-2",
    src: _imports_0
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-12 text-bolder" }, "\n          あなたのご招待が介護・医療業界の支えになります\n        ")
], -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"banner-subsection-container mt-3\" data-v-0af4488f><div class=\"banner-subsection\" data-v-0af4488f>\n          有資格者の<br data-v-0af4488f><span class=\"highlight\" data-v-0af4488f>スキマ時間が<br data-v-0af4488f>社会に役立つ</span></div> <div class=\"banner-subsection\" data-v-0af4488f>\n          現場の<span class=\"highlight\" data-v-0af4488f>人材不足<br data-v-0af4488f>解消やサービス<br data-v-0af4488f>向上</span>に繋がる\n        </div> <div class=\"banner-subsection\" data-v-0af4488f>\n          利用者・患者に<br data-v-0af4488f><span class=\"highlight\" data-v-0af4488f>サービスが<br data-v-0af4488f>行き届く</span></div></div>", 1)
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-flex justify-content-center mt-3 text-bolder" }, "\n        ぜひご協力をお願いします！\n      ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-flex justify-content-center text-size-14 mr-2" }, "\n          カイテクへの招待を投稿する\n        ", -1))
const _hoisted_20 = { class: "refer-promotion px-3 pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_SNSLink = _resolveComponent("SNSLink")!
  const _component_ReferNav = _resolveComponent("ReferNav")!
  const _component_ReferrerTab = _resolveComponent("ReferrerTab")!
  const _component_ReferredTab = _resolveComponent("ReferredTab")!

  return (_ctx.promotion)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header, null, {
          left: _withCtx(() => [
            _createVNode(_component_FeatherIcon, {
              icon: "chevron-left",
              onClick: _ctx.onClickBack
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createTextVNode("\n      招待キャンペーン\n    ")
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(),
                _createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formattedReferPromotionPoint), 1),
                  _hoisted_8,
                  _createTextVNode(),
                  _hoisted_9
                ]),
                _createTextVNode(),
                _hoisted_10,
                _createTextVNode(),
                _createElementVNode("span", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.yenConversionReferPoint) + "円", 1),
                  _createTextVNode(),
                  _hoisted_14
                ])
              ]),
              _createTextVNode(),
              _hoisted_15
            ])
          ]),
          _createTextVNode(),
          _hoisted_16,
          _createTextVNode(),
          _hoisted_17,
          _createTextVNode(),
          _hoisted_18,
          _createTextVNode(),
          _createElementVNode("div", null, [
            _hoisted_19,
            _createTextVNode(),
            _createVNode(_component_SNSLink, { onClick: _ctx.onClickSNSLink }, null, 8, ["onClick"])
          ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", null, [
          _createVNode(_component_ReferNav)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_20, [
          (_ctx.isActiveTab('referrer'))
            ? (_openBlock(), _createBlock(_component_ReferrerTab, {
                key: 0,
                promotion: _ctx.promotion,
                pointAppliedPromotion: _ctx.pointAppliedPromotion,
                countAppliedPromotion: _ctx.countAppliedPromotion,
                userData: _ctx.userData,
                onClick: _ctx.copyPromotionCode
              }, null, 8, ["promotion", "pointAppliedPromotion", "countAppliedPromotion", "userData", "onClick"]))
            : (_ctx.isActiveTab('referred'))
              ? (_openBlock(), _createBlock(_component_ReferredTab, {
                  key: 1,
                  promotionCode: _ctx.promotionCode,
                  "onUpdate:promotionCode": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.promotionCode) = $event)),
                  alreadyReferred: _ctx.alreadyReferred,
                  alreadyWorked: _ctx.alreadyWorked,
                  canApplyPromotion: _ctx.canApplyPromotion,
                  onClick: _ctx.applyPromotion
                }, null, 8, ["promotionCode", "alreadyReferred", "alreadyWorked", "canApplyPromotion", "onClick"]))
              : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}